export default __webpack_public_path__ + "locales/ja-JP/DeleteProfileEverDialog.json?hash=86e388f18c1da1983cd195a5443136e5";